/*global dataLayer*/
/**
 * @overview Helpers for Google Analytics.
 *
 * @module search/analytics
 */


/**
 * Push updates to SERP results to GTM.
 *
 * @param {object} serpData
 */
export function pushUpdatesToDataLayer (serpData) {
    // clear it out before the new update
    dataLayer.push({ serpData: undefined });
    const parsedData = JSON.parse(serpData);
    dataLayer.push({ event: 'trackPageview', serpData: parsedData ? parsedData.serpData : undefined });
}
